<template>
  <Page title="Browse Samples">
    <v-expansion-panels flat v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Filters
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-form @submit.prevent="">
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="options.params.search"
                  label="Search"
                  clearable
                  @input="sampleSearch"
                  @change="sampleSearch"
                  @keydown.enter.prevent
                  @keydown.esc="clearInputs()"
                  @click:clear="clearInputs()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense> </v-row>
            <v-row dense>
              <v-col>
                <v-select
                  :items="feed_types"
                  label="Feed Type"
                  no-data-text="No feed types to select from"
                  item-text="title"
                  item-value="id"
                  v-model="options.params.feed_type_id"
                  @input="filterSamples"
                  @change="filterSamples"
                  clearable
                  @click:clear="clearInputs()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  :items="sample_statuses"
                  label="Sample Status"
                  v-model="options.params.sample_status_id"
                  item-text="title"
                  item-value="id"
                  clearable
                ></v-select>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <v-text-field
                  label="Barcode From"
                  v-model="barcodeFrom"
                  v-mask="barcodeMask"
                  clearable
                  @keydown.esc="clearInputs()"
                  @click:clear="clearInputs()"
                  maxlength="9"
                  :error-messages="barcodeError ? [barcodeError] : []"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Barcode To"
                  v-model="barcodeTo"
                  v-mask="barcodeMask"
                  clearable
                  @keydown.esc="clearInputs()"
                  @click:clear="clearInputs()"
                  maxlength="9"
                  :error-messages="barcodeError ? [barcodeError] : []"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <DatePickerInput
                  v-model="options.params.received_from"
                  :datePickerConfig="receivedDateFrom"
                  @updateDateField="updateDateField"
                ></DatePickerInput>
              </v-col>
              <v-col cols="12" sm="6">
                <DatePickerInput
                  v-model="options.params.received_to"
                  :datePickerConfig="receivedDateTo"
                  @updateDateField="updateDateField"
                ></DatePickerInput>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col v-if="hasMultipleClients" cols="12" sm="6">
                <v-select
                  :items="clients"
                  item-value="id"
                  item-text="title_with_id"
                  label="Client"
                  :disabled="!user.is_copy_to"
                  v-model="options.params.client_id"
                  @click:clear="clearInputs"
                />
              </v-col>
            </v-row>
            <v-row dense v-if="$route.query.is_pending">
              <v-col>
                <v-checkbox
                  v-model="options.params.is_pending"
                  label="Is Pending"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row dense v-if="$route.query.created_today">
              <v-col>
                <v-checkbox
                  v-model="options.params.created_today"
                  label="Created Today"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row dense>
      <v-col class="text-right">
        <v-menu transition="slide-y-transition" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              :disabled="!selected.length"
              v-bind="attrs"
              v-on="on"
            >
              Bulk Actions
              {{ selected.length ? `(${selected.length})` : "" }}
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item @click="sampleShipmentDialog = true">
              <v-list-item-title>Assign to New Shipment</v-list-item-title>
            </v-list-item> -->
            <v-list-item
              @click="showBulkSampleEditDialog"
              :disabled="
                this.selected.some(item => item.sample_status_id !== 1)
              "
              v-if="!user.is_copy_to"
            >
              <v-list-item-title>Bulk Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="triggerDownloadReports">
              <v-list-item-title>Create Report</v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportStandardXml">
              <v-list-item-title>Export Standard-XML</v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportXmlData">
              <v-list-item-title>Export XML-Data</v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportAXml">
              <v-list-item-title>Export A-XML</v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportNitCow">
              <v-list-item-title>Export nit-cow-data.txt</v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportFullCsv">
              <v-list-item-title>Create CSV File</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-subheader
              >Custom CSVs:
              <v-spacer></v-spacer>
              <router-link to="/reports/custom-csvs/">
                manage
              </router-link>
            </v-subheader>
            <v-list-item
              v-for="csv in csvs"
              :key="csv.id"
              @click="exportCustomCsv(csv)"
            >
              <v-list-item-title>Export CSV: {{ csv.name }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!csvs.length" disabled>
              <v-list-item-title>(No Custom CSVs Set Up)</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selected"
      v-bind="customAttrs"
      :options.sync="options"
      show-select
      no-data-text="No samples found"
    >
      <!-- <template v-slot:item.Farms.title="{ item }">
        <span v-if="item.farm">{{ item.farm.title }}</span>
        <span v-else-if="item.source_other"
          >Other: {{ item.source_other }}</span
        >
      </template> -->
      <!-- <template v-slot:[`item.reference_code`]="{ item }">
        {{ hexadecimalId(item.slug) }}
      </template> -->

      <template v-slot:item.farm.title="{ item }">
        <v-tooltip
          bottom
          v-if="
            item?.farm &&
              item?.farm?.title.length &&
              item?.farm?.title.length > 15
          "
          max-width="50%"
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              style="max-width: 8rem;
              text-overflow: ellipsis; 
              white-space: nowrap; 
              overflow: hidden;
              display: flex;
              align-items: center;
              margin: auto;"
              v-bind="attrs"
              v-on="on"
            >
              {{ item?.farm?.title }}
            </p>
          </template>
          <template v-slot:default>
            <div class="custom-tooltip">
              {{ item?.farm?.title }}
            </div>
          </template>
        </v-tooltip>
        <p
          v-else
          style="max-width: 8rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: flex;
          align-items: center;
          margin: auto;"
        >
          {{ item?.farm?.title }}
        </p>
      </template>
      <template v-slot:item.FeedTypes.title="{ item }">
        <!-- <span v-if="item.feed_type">{{ item.feed_type.title }}</span> -->
        <v-tooltip
          bottom
          v-if="
            item?.feed_type &&
              item?.feed_type?.title.length &&
              item?.feed_type?.title.length > 15
          "
          max-width="50%"
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              style="max-width: 8rem;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              display: flex;
              align-items: center;
              margin: auto;"
              v-bind="attrs"
              v-on="on"
            >
              {{ item?.feed_type?.title }}
            </p>
          </template>
          <template v-slot:default>
            <div class="custom-tooltip">
              {{ item?.feed_type?.title }}
            </div>
          </template>
        </v-tooltip>
        <p
          v-else
          style="max-width: 8rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: flex;
          align-items: center;
          margin: auto;"
        >
          {{ item?.feed_type?.title }}
        </p>
      </template>
      <!-- <template v-slot:item.description="{ item }">
        <p
          style="max-width: 8rem; text-overflow: ellipsis; white-space: wrap; text-wrap: wrap;"
        >
          {{ item.description }}
        </p>
      </template> -->

      <!-- <template v-slot:item.description="{ item }">
  <v-tooltip bottom v-if="item.description.length > 60">
    <template v-slot:activator="{ on, attrs }">
      <p
        style="max-width: 8rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
        v-bind="attrs" v-on="on"
      >
        {{ item.description }}
      </p>
    </template>
    <span style="word-wrap: break-word; max-width: 2%; background-color: blue;">{{ item.description }}</span>
  </v-tooltip>
  <p
    v-else
    style="max-width: 8rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
  >
    {{ item.description }}
  </p>
</template> -->
      <template v-slot:item.created="{ item }">
        <div style="width: 7rem;">
          {{ formatDate(item.created) }}
        </div>
      </template>
      <template v-slot:item.description="{ item }">
        <v-tooltip
          bottom
          v-if="
            item.description &&
              item.description.length &&
              item.description.length > 20
          "
          max-width="50%"
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              style="max-width: 6rem; 
              text-overflow: ellipsis; 
              white-space: nowrap; 
              overflow: hidden;
              display: flex;
              align-items: center;
              margin: auto;"
              v-bind="attrs"
              v-on="on"
            >
              {{ item.description }}
            </p>
          </template>
          <template v-slot:default>
            <div class="custom-tooltip">
              {{ item.description }}
            </div>
          </template>
        </v-tooltip>
        <p
          v-else
          style="max-width: 8rem; 
          text-overflow: ellipsis; 
          white-space: nowrap;
          overflow: hidden;
          display: flex;
          align-items: center;
          margin: auto;"
        >
          {{ item.description }}
        </p>
      </template>

      <template v-slot:item.date_collected="{ item }">
        <div style="width: 7rem;">
          <span v-if="item.date_collected">{{
            formatDate(item.date_collected)
          }}</span>
        </div>
      </template>
      <template v-slot:item.TestPackages="{ item }">
        <div v-if="item.test_packages.length > 3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <ul>
                <li v-for="index in 3" :key="index">
                  <span v-bind="attrs" v-on="on"
                    >{{ item.test_packages[index].title
                    }}<span v-if="index !== 3">,</span></span
                  >
                </li>
                <li>
                  <span v-bind="attrs" v-on="on"> ... </span>
                </li>
              </ul>
            </template>
            <ul>
              <li
                v-for="(test_package, index) in item.test_packages"
                :key="index"
              >
                {{ test_package.title
                }}<span v-if="index < item.test_packages.length">,</span>
              </li>
            </ul>
          </v-tooltip>
        </div>
        <div v-else>
          <ul>
            <li
              v-for="(test_package, index) in item.test_packages"
              :key="index"
            >
              {{ test_package.title
              }}<span v-if="index < item.test_packages.length - 1">,</span>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:item.TestComponents="{ item }">
        <div
          v-if="
            item.test_components.filter(
              item => !item._joinData.package_id && !item.is_internal
            ).length > 3
          "
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <ul>
                <li
                  v-for="(comp, index) in filtered_test_components(item).slice(
                    0,
                    3
                  )"
                  :key="comp.id"
                >
                  <span v-bind="attrs" v-on="on">
                    {{ comp.title }}<span v-if="index !== 2">,</span>
                  </span>
                </li>
                <li>
                  <span v-bind="attrs" v-on="on"> … </span>
                </li>
              </ul>
            </template>
            <ul>
              <li
                v-for="(comp, index) in filtered_test_components(item)"
                :key="comp.id"
              >
                {{ comp.title
                }}<span v-if="index < filtered_test_components(item).length - 1"
                  >,</span
                >
              </li>
            </ul>
          </v-tooltip>
        </div>

        <div v-else>
          <ul>
            <li
              v-for="(comp, index) in filtered_test_components(item)"
              :key="comp.id"
            >
              {{ comp.title
              }}<span v-if="index < filtered_test_components(item).length - 1"
                >,</span
              >
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:item.ShipmentSampleReceived.received_at="{ item }">
        <div style="width: 6rem;">
          <div v-if="item.shipments_samples_received">
            {{ formatDate(item.shipments_samples_received.received_at) }}
          </div>
        </div>
      </template>
      <template v-slot:item.sample_status.title="{ item }">
        <div style="width: 6rem;">
          {{ item.sample_status.title }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="min-width: 14rem;">
          <span v-if="!isLocked(item)">
            <template v-if="!user.is_copy_to">
              <v-tooltip top z-index="2">
                <template v-slot:activator="{ on, attrs }">
                  <router-link
                    :to="
                      item.sample_status_id === 1
                        ? {
                            name: 'New Sample Images',
                            params: { sampleId: item.slug }
                          }
                        : ''
                    "
                    :class="
                      item.sample_status_id === 1
                        ? 'cursor-pointer'
                        : 'cursor-not-allowed'
                    "
                  >
                    <v-icon
                      :color="
                        item.sample_status_id === 1 ? '' : 'grey lighten-1'
                      "
                      class="action-icon"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-image
                    </v-icon>
                  </router-link>
                </template>
                <span>{{
                  item.sample_status_id === 1
                    ? `Sample Images`
                    : `${item.sample_status.title} sample cannot be edited`
                }}</span>
              </v-tooltip>
              <!--              <v-tooltip top z-index="2" v-else>-->
              <!--                <template v-slot:activator="{ on, attrs }">-->
              <!--                  <v-icon-->
              <!--                    class="action-icon"-->
              <!--                    v-bind="attrs"-->
              <!--                    color="grey lighten-1"-->
              <!--                    v-on="on"-->
              <!--                  >-->
              <!--                    mdi-image-->
              <!--                  </v-icon>-->
              <!--                </template>-->
              <!--                <span>Received samples cannot be edited</span>-->
              <!--              </v-tooltip>-->
            </template>
            <template v-if="!user.is_copy_to">
              <v-tooltip top z-index="2">
                <template v-slot:activator="{ on, attrs }">
                  <router-link
                    :to="
                      item.sample_status_id === 1
                        ? {
                            name: 'New Sample Edit',
                            params: { sampleId: item.id }
                          }
                        : ''
                    "
                  >
                    <v-icon
                      class="action-icon"
                      v-bind="attrs"
                      v-on="on"
                      :color="
                        item.sample_status_id === 1 ? '' : 'grey lighten-1'
                      "
                      :class="
                        item.sample_status_id === 1
                          ? 'cursor-pointer'
                          : 'cursor-not-allowed'
                      "
                    >
                      mdi-pencil
                    </v-icon>
                  </router-link>
                </template>
                <span>{{
                  item.sample_status_id === 1
                    ? `Edit Sample`
                    : `${item.sample_status.title} sample cannot be edited`
                }}</span>
              </v-tooltip>
              <!--              <v-tooltip top z-index="2" v-else>-->
              <!--                <template v-slot:activator="{ on, attrs }">-->
              <!--                  <v-icon-->
              <!--                    style="margin-left: 8px;"-->
              <!--                    class="action-icon"-->
              <!--                    v-bind="attrs"-->
              <!--                    v-on="on"-->
              <!--                    color="grey lighten-1"-->
              <!--                  >-->
              <!--                    mdi-pencil-->
              <!--                  </v-icon>-->
              <!--                </template>-->
              <!--                <span>Received samples cannot be edited</span>-->
              <!--              </v-tooltip>-->
            </template>
            <template v-if="!user.is_copy_to">
              <v-tooltip top z-index="2">
                <template v-slot:activator="{ on, attrs }">
                  <button
                    @click="openSampleDeleteDialog(item)"
                    :class="
                      item.sample_status_id === 1
                        ? 'cursor-pointer'
                        : 'cursor-not-allowed'
                    "
                  >
                    <v-icon
                      class="action-icon"
                      v-bind="attrs"
                      v-on="on"
                      :color="
                        item.sample_status_id === 1 ? '' : 'grey lighten-1'
                      "
                    >
                      mdi-delete
                    </v-icon>
                  </button>
                </template>
                <span>{{
                  item.sample_status_id === 1
                    ? `Delete Sample`
                    : `${item.sample_status.title} sample cannot be deleted`
                }}</span>
              </v-tooltip>
              <!--              <v-tooltip top z-index="2" v-else>-->
              <!--                <template v-slot:activator="{ on, attrs }">-->
              <!--                  <v-icon-->
              <!--                    class="action-icon"-->
              <!--                    color="grey lighten-1"-->
              <!--                    v-bind="attrs"-->
              <!--                    v-on="on"-->
              <!--                  >-->
              <!--                    mdi-delete-->
              <!--                  </v-icon>-->
              <!--                </template>-->
              <!--                <span>Received samples cannot be deleted</span>-->
              <!--              </v-tooltip>-->
            </template>
            <v-tooltip top z-index="2">
              <template v-slot:activator="{ on, attrs }">
                <router-link
                  :to="{
                    name: 'New Sample View',
                    params: { sampleId: item.id }
                  }"
                >
                  <v-icon class="action-icon" v-bind="attrs" v-on="on">
                    mdi-eye
                  </v-icon>
                </router-link>
              </template>
              <span>View Sample</span>
            </v-tooltip>
            <span>
              <v-tooltip top z-index="2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="action-icon"
                    @click.stop="() => toggleItem(item)"
                    v-bind="attrs"
                    v-on="on"
                    :color="item.is_active ? 'error' : 'success'"
                  >
                    <!-- {{ item.is_active ? "mdi-cancel" : "mdi-check" }} -->
                  </v-icon>
                </template>
                <!-- <span>{{ item.is_active ? "Cancel" : "Activate" }} Sample</span> -->
              </v-tooltip>
            </span>
          </span>
          <span>
            <v-tooltip top z-index="2">
              <template v-slot:activator="{ on, attrs }">
                <span class="mx-2">
                  <v-icon
                    @click.stop="() => sampleStatusModal(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-progress-clock
                  </v-icon>
                </span>
              </template>
              <span>Sample Status</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                item.test_components.some(
                  compomnent =>
                    compomnent._joinData.sample_test_component_status_id == 2 ||
                    compomnent._joinData.sample_test_component_status_id == 6
                )
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <span class="mx-2">
                  <button @click="getUrl(item.id)" target="_blank">
                    <v-icon v-bind="attrs" v-on="on">
                      mdi-file
                    </v-icon>
                  </button>
                </span>
              </template>
              <span>Download Report PDF</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on, attrs }">
                <span class="mx-2">
                  <v-icon
                    v-bind="attrs"
                    class="cursor-not-allowed"
                    color="grey lighten-1"
                    v-on="on"
                  >
                    mdi-file
                  </v-icon>
                </span>
              </template>
              <span>Can't Download Report PDF</span>
            </v-tooltip>
          </span>
        </div>
      </template>
    </v-data-table>
    <SampleDeleteDialog
      v-model="deleteSampleDialog"
      :sampleId="toBeDeletedSampleId"
      @delete-result="handleDeleteResult"
    />

    <SampleToggleDialog
      v-model="toggleSampleItem"
      v-on:sample-update="onSampleUpdate"
    />
    <v-dialog v-model="sampleShipmentDialog" width="600">
      <SampleShipment
        :samples="selected"
        v-on:close="sampleShipmentDialogClose"
      />
    </v-dialog>
    <v-dialog
      v-model="sample_status.active"
      content-class="status-dialog"
      width="900"
    >
      <SampleStatus
        v-if="sample_status.item !== false"
        v-model="sample_status.item"
        :sample_statuses="this.sample_statuses"
        :notes="this.currentSampleNotes"
        v-on:close-dialog="() => sampleStatusModal(false)"
        v-on:refresh="() => refresh()"
      />
    </v-dialog>
    <BulkSampleEditDialog
      v-model="isBulkSampleEditDialog"
      :sampleIds="selectedSamplesIds"
      @bulkEditSaved="getPaginatedDebounced"
    />
  </Page>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Page from "@/components/layout/Page";
import SampleToggleDialog from "@/components/samples/components/SampleToggleDialog";
import SampleShipment from "@/components/samples/components/SampleShipment";
import SampleStatus from "@/components/samples/components/SampleStatus";
import dataTablePagination from "@/mixins/dataTablePagination";
import DatePickerInput from "@/components/formElements/DatePickerInput";
import BulkSampleEditDialog from "@/components/newSamples/components/BulkSampleEditDialog";
import dayjs from "dayjs";
import rules from "@/utils/rules";
import { getBaseUrl } from "@/utils";
import SampleDeleteDialog from "./components/SampleDeleteDialog.vue";
import { mapFields } from "vuex-map-fields";

export default {
  name: "SamplesBrowse",
  components: {
    Page,
    SampleToggleDialog,
    SampleShipment,
    DatePickerInput,
    SampleStatus,
    SampleDeleteDialog,
    BulkSampleEditDialog
  },
  mixins: [dataTablePagination],
  data() {
    return {
      loading: false,
      rules: {
        numeric: [rules.numeric]
      },
      panel: null,
      pdfUrl: "sample-pdf-reports",
      selectedSamplesIds: "",
      isBulkSampleEditDialog: false,
      barcodeFrom: "",
      barcodeTo: "",
      barcodeError: "",
      barcodeMask: "#########",
      headers: [
        { text: "Lab ID", value: "slug" },
        { text: "Bag Barcode", value: "sample_bag_barcode" },
        { text: "Sample ID", value: "sample_id_barcode" },
        { text: "Farm Name", value: "farm.title", sortable: false },
        { text: "Feed Type", value: "FeedTypes.title" },
        { text: "Created At", value: "created" },
        { text: "Description", value: "description", sortable: false },
        { text: "Test Packages", value: "TestPackages", sortable: false },
        { text: "Test Components", value: "TestComponents", sortable: false },
        {
          text: "Received Date",
          value: "ShipmentSampleReceived.received_at",
          dataType: "Date"
        },
        { text: "Status", value: "sample_status.title" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      currentSampleNotes: "",
      options: {
        itemsPerPage: 15,
        params: {
          feed_type_id: null,
          sample_status_id: null,
          client_id: null,
          barcode_from: null,
          barcode_to: null,
          received_to: null,
          received_from: null,
          search: "",
          is_pending: this.$route.query.is_pending,
          created_today: this.$route.query.created_today
        }
      },
      selected: [],
      toggleSampleItem: false,
      deleteSampleDialog: false,
      sampleShipmentDialog: false,
      toBeDeletedSampleId: null,
      receivedDateFrom: {
        label: "Received From",
        field: "received_from",
        minDate: null,
        maxDate: dayjs(new Date()).format("YYYY-MM-DD")
      },
      receivedDateTo: {
        label: "Received To",
        field: "received_to",
        minDate: null,
        maxDate: dayjs(new Date()).format("YYYY-MM-DD")
      },
      dateCollected: {
        label: "Sampled Date",
        field: "date_collected"
      },
      sample_status: {
        active: false,
        item: false
      }
    };
  },
  computed: {
    ...mapState("samples", { samples: "items" }),
    ...mapState("csvs", { csvs: "allItems" }),
    ...mapState("clients", { clients: "items" }),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapState("auth", ["user"]),
    ...mapFields("auth", ["user"]),
    ...mapGetters("baseData", [
      "getInvoicedStatusId",
      "feed_types",
      "sample_statuses"
    ]),
    ...mapGetters("baseData", ["getById", "test_components"]),
    ...mapGetters("baseData", { allPackages: "test_packages" }),
    ...mapGetters("clients", ["hasMultipleClients"]),
    filteredHeaders() {
      return this.headers.filter(this.filterHeaders);
    },
    adjustedAttrs() {
      return { ...this.defaultAttrs, headers: this.filteredHeaders };
    },
    customAttrs() {
      return {
        ...this.defaultAttrs,
        items: this.items
      };
    }
    // filtered_test_components(sample) {
    //   let ids = sample.test_components
    //     .filter(item => !item.is_internal)
    //     .map(item => item.id);
    //   if (sample.test_packages && sample.test_packages.length) {
    //     const packageComponents = this.allPackages.find(
    //       item => item.id === sample.test_packages[0].id
    //     ).test_components;
    //     ids = [
    //       // Include initial ids
    //       ...ids,
    //       // Add package component ids
    //       ...packageComponents.map(item => item.id)
    //     ];
    //   }
    //   // Return the filtered list of components included in this sample
    //   return this.test_components.filter(item => ids.indexOf(item.id) !== -1);
    // }
  },
  watch: {
    "options.params.received_from"(newVal) {
      this.receivedDateTo.minDate = newVal || null;
      this.selected = [];
    },
    "options.params.received_to"(newVal) {
      this.receivedDateFrom.maxDate = newVal || null;
      this.selected = [];
    },
    "options.params.sample_status_id"() {
      this.selected = [];
    },
    "options.params.feed_type_id"() {
      this.selected = [];
    },
    "options.params.is_pending"(value) {
      this.selected = [];

      const query = { ...this.$route.query };

      query.is_pending = String(!!value);

      this.$set(this.options.params, "is_pending", value);

      this.$router.replace({
        path: this.$route.path,
        query
      });
    },
    "options.params.created_today"(value) {
      this.selected = [];

      const query = { ...this.$route.query };

      query.created_today = String(!!value);

      this.$set(this.options.params, "created_today", value);

      this.$router.replace({
        path: this.$route.path,
        query
      });
    },
    selectedClient(newVal) {
      this.options.params.client_id = newVal ? newVal.id : null;
      this.client_id = newVal ? newVal.id : null;
      this.selected = [];
      if (newVal && newVal.id) {
        this.getActiveFarms(newVal.id);
      }
    },
    "options.params.client_id"(newVal) {
      Promise.all([this.getAllCsvs(newVal)]).then(() => (this.loading = false));
      this.selected = [];
    },
    deleteSampleDialog(val) {
      console.log(val);
    },
    barcodeFrom(value) {
      if (value == "" || value.length < 7) {
        this.barcodeError = "";
      }
      if (value?.length >= 7 && value?.length <= 9) {
        this.options.params.barcode_from = value;

        if (
          this.barcodeTo &&
          this.barcodeTo.length >= 7 &&
          this.barcodeTo.length <= 9
        ) {
          if (Number(this.barcodeTo) < Number(value)) {
            this.barcodeError =
              "Barcode To must be greater than or equal to Barcode From";
            return;
          }
        }

        this.barcodeError = "";
        this.sampleSearch();
      }
    },
    barcodeTo(value) {
      if (value == "" || value.length < 7) {
        this.barcodeError = "";
      }
      if (value?.length >= 7 && value?.length <= 9) {
        this.options.params.barcode_to = value;

        if (
          this.barcodeFrom &&
          this.barcodeFrom.length >= 7 &&
          this.barcodeFrom.length <= 9
        ) {
          if (Number(value) < Number(this.barcodeFrom)) {
            this.barcodeError =
              "Barcode To must be greater than or equal to Barcode From";
            return;
          }
        }

        this.barcodeError = "";
        this.sampleSearch();
      }
    }
  },
  methods: {
    ...mapActions(["notify"]),
    ...mapActions("samples", ["logSampleTransaction", "deleteSample"]),
    ...mapActions("samples", ["getPaginated", "getFile"]),
    ...mapActions("csvs", ["getCsvs"]),
    ...mapActions("farms", ["getActiveFarms"]),
    ...mapActions("csvs", ["getAllCsvs"]),
    ...mapActions("baseData", ["getSampleStatuses", "getFeedTypes"]),
    ...mapActions("reports", [
      "getReports",
      "downloadReports",
      "downloadSampleReport"
    ]),
    ...mapActions("baseData", [
      "getTestPackageCategories",
      "getPackages",
      "getComponentCategories",
      "getTestComponents"
    ]),
    referenceCodeSearch() {
      this.options.params.search = parseInt(this.referenceCode, 16).toString();
      if (this.options.params.search == "NaN") this.options.params.search = "";
    },

    hexadecimalId(slug) {
      const lastSixChars = slug.slice(-6);
      const decimalValue = Number(lastSixChars);
      return decimalValue.toString(16).toUpperCase();
    },
    async getUrl(id) {
      try {
        // Retrieve the Bearer token from localStorage
        const token = localStorage.getItem("auth_token_default");

        // If no token is found, redirect to login
        if (!token) {
          window.location.href = getBaseUrl();
          return;
        }

        // Construct the URL by adding the Bearer token as a query parameter
        const pdfUrl = `${getBaseUrl()}/${
          this.pdfUrl
        }/${id}?render=pdf&token=${encodeURIComponent(token)}`;

        // Open the URL in a new tab
        window.open(pdfUrl, "_blank");
      } catch (error) {
        // Handle errors, such as 401 Unauthorized or 500 Internal Server Error
        if (error.response && error.response.status === 401) {
          alert("Your session has expired. Redirecting to login.");
          window.location.href = getBaseUrl();
        } else if (error.response && error.response.status === 500) {
          alert("Server error: Unable to generate the PDF.");
        } else {
          console.error(
            "Error opening PDF:",
            error.response ? error.response.data : error.message
          );
          alert("An error occurred while opening the PDF.");
        }
      }
    },
    downloadPDF(itemId) {
      const url = this.getUrl(itemId);

      // Create an anchor element and programmatically trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank"; // open in new tab
      link.download = `report-${itemId}.pdf`; // set the download attribute

      // Append the link to the body, trigger the click and remove the element
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    filterSamples() {
      this.getPaginated();
      this.selected = [];
    },
    sampleSearch() {
      this.options.params.search = this.options.params.search.trim();
      this.filterSamples();
    },
    ...mapMutations(["setLoading"]),
    filterHeaders(header) {
      const xs = ["Ref ID", "Sample ID", "Farm Name", "Description", "Actions"];
      if (this.$vuetify.breakpoint.xsOnly) return xs.includes(header.text);
      else if (this.$vuetify.breakpoint.smOnly)
        return [...xs, "Feed Type"].includes(header.text);
      else return true;
    },
    triggerDownloadReports() {
      if (!this.isAllSelectedReleased(this)) {
        return;
      }

      this.setLoading({
        message: "Downloading Report...",
        opacity: 0.5,
        overlay: true
      });
      console.log(`Creating Report for samples ${this.getSelectedForUrl()}`);
      this.logSampleTransaction({
        logData: `Creating Report for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
      this.downloadReports({
        sample_ids: this.selected.map(item => item.id)
      })
        .then(() => this.setLoading({}))
        .then(() =>
          console.log(
            `Downloading Report for samples ${this.getSelectedForUrl()}`
          )
        )
        .then(() =>
          this.logSampleTransaction({
            logData: `Downloading Report for samples ${this.getSelectedForUrl()}`,
            user: this.user.id,
            scope: "samples-api"
          })
        );
    },
    isLocked(item) {
      return (
        item &&
        item.sample_status_id &&
        item.sample_status_id === this.getInvoicedStatusId
      );
    },
    // Ensure all selected samples are released or generate errors and return false
    isAllSelectedReleased(items) {
      const selectedNotReceived = items.selected.filter(item => {
        if (
          item.sample_status_id < 5 ||
          item.sample_status_id == 11 ||
          item.sample_status_id == 12
        ) {
          return item.id;
        }
      });

      if (selectedNotReceived.length > 0) {
        this.notify({
          message:
            "Sample #" +
            selectedNotReceived.map(item => item.id).join(", ") +
            " do not have the accepted statuses."
        });
      } else {
        return true;
      }
    },
    sampleShipmentDialogClose(update = false) {
      this.sampleShipmentDialog = false;
      if (update) {
        this.getPaginatedDebounced();
        this.selected = [];
      }
    },
    toggleItem(item) {
      // Set the toggle item (false|sample)
      this.toggleSampleItem = item;
    },
    onSampleUpdate(res) {
      if (res.success && res.data) {
        // Update the component item data
        const i = this.items.findIndex(item => item.id === res.data.id);
        Vue.set(this.items, i, {
          ...this.items[i],
          ...res.data
        });
      }
      // Update loading status
      this.loading = res.loading !== undefined ? res.loading : false;
    },
    editItem(item) {
      this.$router.push(`/samples/sample-wizard/${item.id}`);
    },
    formatDate(value) {
      return value ? dayjs(String(value)).format("MM/DD/YYYY") : "";
    },
    updateDateField(field, value) {
      this.options.params[field] = value;
    },
    getSelectedForUrl() {
      const params = { samples: this.selected.map(item => item.id) };
      return Object.keys(params)
        .filter(key => params[key])
        .map(key => key + "=" + params[key])
        .join("&");
    },
    exportStandardXml() {
      if (!this.isAllSelectedReleased(this)) {
        return;
      }
      console.log(
        `Exporting Standard XML File for samples ${this.getSelectedForUrl()}`
      );
      this.logSampleTransaction({
        logData: `Exporting Standard XML File for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
      this.getFile({
        url: "/samples/export/standard-xml",
        data: this.getSelectedForUrl(),
        type: "application/xml",
        mode: "download",
        filenamePrefix: "XMLStandardReport"
      });
    },
    exportXmlData() {
      if (!this.isAllSelectedReleased(this)) {
        return;
      }
      console.log(
        `Exporting XML Report for samples ${this.getSelectedForUrl()}`
      );
      this.logSampleTransaction({
        logData: `Exporting XML Report for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
      this.getFile({
        url: "/samples/export/xml-data",
        data: this.getSelectedForUrl(),
        type: "application/xml"
      });
    },
    exportAXml() {
      if (!this.isAllSelectedReleased(this)) {
        return;
      }
      console.log(
        `Exporting A XML Report for samples ${this.getSelectedForUrl()}`
      );
      this.logSampleTransaction({
        logData: `Exporting A XML Report for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
      this.getFile({
        url: "/samples/export/a-xml",
        data: this.getSelectedForUrl(),
        type: "application/xml"
      });
    },
    exportNitCow() {
      if (!this.isAllSelectedReleased(this)) {
        return;
      }
      console.log(
        `Exporting XML Report for samples ${this.getSelectedForUrl()}`
      );
      this.logSampleTransaction({
        logData: `Exporting XML Report for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
      this.getFile({
        url: "/samples/export/nit-cow-data",
        data: this.getSelectedForUrl(),
        type: "text/csv"
      });
    },
    exportFullCsv() {
      if (!this.isAllSelectedReleased(this)) {
        return;
      }
      console.log(`Exporting CSV File for samples ${this.getSelectedForUrl()}`);
      this.logSampleTransaction({
        logData: `Exporting CSV File for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
      this.getFile({
        url: "/samples/export/csv",
        data: this.getSelectedForUrl(),
        type: "text/csv"
      });
    },
    exportCustomCsv(csv) {
      this.getFile({
        url: "/samples/export/custom-csv/" + csv.id + "/",
        data: this.getSelectedForUrl(),
        filename: csv.name,
        type: "text/csv"
      });
      this.logSampleTransaction({
        logData: `Exporting Custom CSV File for samples ${this.getSelectedForUrl()}`,
        user: this.user.id,
        scope: "samples-api"
      });
    },
    sampleStatusModal(item = false) {
      this.currentSampleNotes = item.notes;
      this.sample_status.active = item !== false;
      this.sample_status.item = item;
    },
    triggerDownloadSampleReport(item) {
      this.setLoading({
        message: "Downloading Report...",
        opacity: 0.5,
        overlay: true
      });
      this.downloadSampleReport({
        id: item.id
      }).then(() => this.setLoading({}));
    },
    filterShipments: function(shipmentId) {
      this.options.params.shipment_id = shipmentId;
      this.getPaginatedDebounced();
      this.selected = [];
    },
    clearInputs() {
      this.options.params.search = "";
      this.getPaginatedDebounced();
      this.search = "";
      this.selected = [];
    },
    filtered_test_components(sample) {
      let ids = sample.test_components
        .filter(item => !item.is_internal && !item._joinData.package_id)
        .map(item => item.id);

      if (sample.test_packages && sample.test_packages.length) {
        const packageComponents = this.allPackages.find(
          item => item.id === sample.test_packages[0].id
        )?.test_components;

        if (packageComponents) {
          ids = [
            // Include initial IDs
            ...ids
            // Add package component IDs
            // ...packageComponents.map(item => item.id)
          ];
        }
      }

      // Return the filtered list of components included in this sample
      return this.test_components.filter(item => ids.indexOf(item.id) !== -1);
    },
    openSampleDeleteDialog(sample) {
      if (sample.sample_status_id !== 1) return;
      this.toBeDeletedSampleId = sample.id;
      this.deleteSampleDialog = true;
    },
    handleDeleteResult({ success, response, error }) {
      if (success) {
        this.deleteSampleDialog = false;
        const message = "Sample deleted successfully!";
        this.notify({ message, route: "" });
        this.getPaginatedDebounced();
      } else {
        console.log(error || response);
        const message = `Error while deleting sample ${error}!`;
        this.notify({ message, route: "", color: "error" });
      }
    },
    showBulkSampleEditDialog() {
      this.selectedSamplesIds = this.selected.map(item => item.id).join(", ");
      this.isBulkSampleEditDialog = true;
    }
  },
  mounted() {
    this.client_id = this.selectedClient.id;
    Promise.all([
      this.getSampleStatuses(),
      this.getFeedTypes(),
      this.getAllCsvs(this.selectedClient.id),
      this.getTestPackageCategories(),
      this.getSampleStatuses(),
      this.getComponentCategories({ client_id: this.selectedClient.id }),
      this.getTestComponents({ client_id: this.selectedClient.id }),
      this.getPackages()
    ]);
  },
  created() {
    if (this.selectedClient) {
      this.options.params.client_id = this.selectedClient.id;
    }
  }
};
</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 80% !important;
}

.container {
  max-width: 100%;
}
</style>

<style lang="scss" scoped>
.v-data-table {
  // Icons with hyperlinks need some spacing so the underlines don't blend
  tr td:last-child a {
    margin: 0 2px;
  }
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.action-icon {
  margin-top: 2px;
  margin-bottom: 4px;
}
ul {
  list-style-type: none;
}
li {
  cursor: default;
}

.custom-tooltip {
  white-space: normal; /* Allow text to wrap */
  word-wrap: break-word; /* Ensure long words break correctly */
  padding: 8px; /* Optional: Add some padding for better readability */
  background: rgba(0, 0, 0, 0); /* Optional: Set a background color */
  border: none; /* Optional: Add a border for better distinction */
  text-align: center;
  margin: auto;
  border-radius: 4px; /* Optional: Rounded corners */
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}
</style>
